import React from 'react';
import cn from 'clsx';

import Button from '../../../../library/button/button';
import Typography from '../../../../library/typography/typography';
import { CheckCircleSolidIcon } from '../../../../shared/icons/icons';
import {
  PACKAGE_STATUS,
  STEP_TYPE
} from '../../tire-wheel-package-status-constants';

import styles from './tire-wheel-package-status-item.scss';

interface TireWheelPackageStatusItemProps {
  count: number;
  onChangeProductInBundle?: () => void;
  status: string;
  text: string;
  type: string;
}

function TireWheelPackageStatusItem(props: TireWheelPackageStatusItemProps) {
  const { count, onChangeProductInBundle, status, text, type } = props;

  const statusItemConfig = {
    [STEP_TYPE.TIRES]: {
      classNames: {
        COMPLETED: 'completed',
        IN_PROGRESS: 'active',
        NOT_STARTED: 'inactive'
      }
    },
    [STEP_TYPE.WHEELS]: {
      classNames: {
        COMPLETED: 'completed',
        IN_PROGRESS: 'active',
        NOT_STARTED: 'inactive'
      }
    },
    [STEP_TYPE.FINALIZE]: {
      classNames: {
        COMPLETED: 'completed',
        IN_PROGRESS: 'active',
        NOT_STARTED: 'inactive'
      }
    }
  };

  if (
    !type ||
    !statusItemConfig[type] ||
    !statusItemConfig[type].classNames[status]
  ) {
    return null;
  }

  return (
    <Button
      className={cn(styles['container'], 'tire-wheel-package-status-item')}
      isDisabled={
        status === PACKAGE_STATUS.NOT_STARTED ||
        status === PACKAGE_STATUS.IN_PROGRESS
      }
      onClick={onChangeProductInBundle}
    >
      <div className={styles['icon-container']}>
        {status === PACKAGE_STATUS.COMPLETED ? (
          <CheckCircleSolidIcon className={styles['completed-icon']} />
        ) : (
          <Typography
            className={
              styles[`${statusItemConfig[type].classNames[status]}-step`]
            }
            tag="span"
            weight="black"
          >
            {count}
          </Typography>
        )}
      </div>
      <Typography
        className={cn(
          styles[`${statusItemConfig[type].classNames[status]}-status`],
          `tire-wheel-package-status-item__${statusItemConfig[type].classNames[status]}-status`
        )}
        tag="span"
        weight={status === PACKAGE_STATUS.IN_PROGRESS ? 'black' : 'normal'}
      >
        {text}
      </Typography>
    </Button>
  );
}

export default TireWheelPackageStatusItem;
